export const defaultContainerWidth = 12;
